<div class="lum-c-rfq-kit-items-warehouse">
  <table class="table">
    <thead>
      <tr>
        <th>Warehouse Group</th>
        <th>SKUs</th>
        <th>Total KIT Items</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let warehouseGroup of warehouseGroups; trackBy: trackById">
        <td>{{ warehouseGroup.name }}</td>
        <td>
          <table class="table table-borderless text-left">
            <thead>
              <tr>
                <th class="w-80">SKU</th>
                <th class="w-80">Location</th>
                <th class="w-40">Available Qty.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of warehouseGroup.items">
                <td>{{ item?.product?.product_name }}</td>
                <td>{{ item?.warehouse?.location_name }}</td>
                <td>
                  {{
                    (item?.qty_onhand | decimalPlaces) -
                      (item?.qty_pending | decimalPlaces) | decimalPlaces
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td>{{ warehouseGroup.total }}</td>
      </tr>
    </tbody>
  </table>
</div>
